<template>
  <div style="width:80%;position:relative;" :key="componentKey">
    <div contenteditable="true" style="border: 0;outline: none;width:100%;position: absolute;z-index: 1;top:0;right:0;" class="itinerary-right-list" ref="listDom" :id="`pdf-many-table${pdfIndex}`" v-for="item,pdfIndex in store.state.dataTickets" :key="pdfIndex">
    <div class="table-box" style="font-family: Arial, 'Microsoft Yahei'; color: #666">
      <div style="width:100%">
        <table border="0" width="100%" cellspacing="1" class="cke_show_border">
          <tbody>
            <tr>
              <td>
                <img
                  :src="store.state.images.IATA_logo"
                  alt="logo"
                />
              </td>
            </tr>
            <hr/>
          </tbody>
        </table>
        <table style="width: 100%" class="cke_show_border">
          <thead>
            <tr>
              <td>
                <label
                  for="tel"
                  style="
                    line-height: 32px;
                    vertical-align: bottom;
                  "
                  >{{store.state.seledLetter == "chTable" ? "电话":'Tel'}}：</label
                >
                <span id="officeTel">{{store.state.phone}}</span>
              </td>
              <td>
                <label
                  for="tel"
                  style="line-height: 32px; vertical-align: bottom"
                  >{{store.state.seledLetter == "chTable" ? "传真":'Fax'}}：</label
                >
                <span id="officeFax">{{store.state.fax}}</span>
              </td>
              <td>
                <label
                  for="tel"
                  style="line-height: 32px; vertical-align: bottom"
                  >{{store.state.seledLetter == "chTable" ? "代理人":'Agent'}}：</label
                >
                <span id="name"> {{store.state.adminName}} </span>
              </td>
            </tr>
          </thead>
        </table>
      </div>
      <div
        style="
        width:100%;
          background-color: #1abc93;
          color: #fff;
          height: 50px;
          font-size: 20px;
          display:flex;
          justify-content: center;
          align-items: center;
        "
      >
        <span>{{store.state.seledLetter == "chTable" ? "行程单":'Itinerary'}}</span>
      </div>
      <div style="width:100%;padding: 0 50px">
        <div class="passenger-title">
          <p v-if="store.state.seledPDF=='many'">{{store.state.seledLetter == "chTable" ? "尊敬的":'Dear traveller'}}：<span v-for="item,index in store.state.dataTickets" :key="index">{{item.PersonName}}</span></p>
          <p v-if="store.state.seledPDF=='one'">{{store.state.seledLetter == "chTable" ? "尊敬的":'Dear traveller'}}：<span id="passengerNameList">{{item.PersonName}}</span></p>
          <p>
            {{store.state.seledLetter == "chTable" ? "感谢您选择我公司为您安排的旅行行程，以下是您此次行程的具体航班信息，请查收":'thank you for booking with us.Please kindly find the flight schedule as well as other information:'}}：
          </p>
          <p><strong>{{store.state.seledLetter == "chTable" ? "记录编号":'Booking Reference'}}：</strong><span id="1EPNRNo">{{store.state.resolveData.Pnr}}</span></p>
        </div>
        <div id="segmentInfo">
          <div id="segmentData"><br /></div>
          <table
            style="
              width: 100%;
              border: 1px solid #1abc93;
              border-radius: 3px;
              border-collapse: collapse;
              text-align: center;
            "
            class="cke_show_border"
          >
            <thead>
              <tr style="height: 30px; font-weight: bold">
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "日期":'Date'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "行程":'Route'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "航班":'Flight No.'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "机型":'Aerocraft'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "起飞-到达":'Dep.-Arr.'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "飞行时间":'Duration'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "舱位":'Class'}}</td>
                <td style="border: 1px solid #1abc93">{{store.state.seledLetter == "chTable" ? "状态":'Status'}}</td>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 30px" v-for="item,index in store.state.resolveData.Flights" :key="index">
                <td style="border: 1px solid #1abc93">
                  <span id="travelDate" v-if="store.state.seledLetter == 'chTable'"> {{ judgmentDate(item.FlightDate.slice(2)) == undefined ? item.FlightDate : judgmentDate(item.FlightDate.slice(2))+ '-' + item.FlightDate.slice(0,2) }} </span>
                  <span id="travelDate" v-if="store.state.seledLetter !== 'chTable'"> {{ item.FlightDate}} </span>
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="departureCityName">{{item.Departure}}</span>
                  <!-- (<span
                    id="departureAptName"
                    >高崎国际机场</span
                  >) -->
                  &nbsp;-&nbsp;<span id="arrivalCityName">{{item.Destination}}</span>
                  <!-- (<span
                    id="arrivalAptName"
                    >素万那普国际机场</span
                  >) -->
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="flightNo">{{item.Flight}}</span>
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="planeType"></span>
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="departureTime">{{item.DepartureTime.slice(0, 2) + ":" + item.DepartureTime.slice(2, 4)}}</span>&nbsp;-&nbsp;<span
                    id="arrivalTime"
                    >{{item.DestinationTime.slice(0, 2) + ":" + item.DestinationTime.slice(2, 4)+(item.ModifyDate == 0 ? '':'+' + item.ModifyDate)}}</span
                  >
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="elapsedTime"></span>
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="cabin">{{item.Position}}</span>
                </td>
                <td style="border: 1px solid #1abc93">
                  <span id="actionCode">{{item.FlightStatus}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="margin-top: 20px">
          <table
            style="width: 100%; margin-bottom: 20px"
            class="cke_show_border item-order-text"
          >
            <tbody>
              <tr>
                <td style="width: 100px; vertical-align: top">
                  <strong>{{store.state.seledLetter == "chTable" ? "票价(含税)":'Air Fare(Include tax)'}}：</strong>
                </td>
                <td>
                  <span id="currencyType_total"></span>&nbsp;&nbsp;<span
                    id="totalAmount"
                    >{{allPrice}}</span
                  >({{store.state.seledLetter == "chTable" ? "含税":'Include tax'}})
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="remark">
          <table
            style="width: 100%; margin-bottom: 20px"
            class="cke_show_border item-order-text"
          >
            <tbody>
              <tr>
                <td style="width: 100px; vertical-align: top">
                  <strong>{{store.state.seledLetter == "chTable" ? "注释":'Remark'}}：</strong>
                </td>
                <td>
                  <div id="remark_decodeAirline">
                    <span id="decodeAirlineCode"></span>&nbsp;-&nbsp;<span
                      id="decodeAirlineName"
                    ></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="tktl"><br /></div>
        <div id="tktInfo">
          <table
            style="width: 100%; margin-bottom: 20px"
            class="cke_show_border item-order-text"
          >
            <tbody>
              <tr>
                <td style="width: 100px; vertical-align: top">
                  <strong>{{store.state.seledLetter == "chTable" ? "票号":'Ticket No'}}：</strong>
                </td>
                <td v-if="store.state.seledPDF=='many'">
                  <span v-for="item,index in store.state.resolveData.Tickets" :key="index">{{ item.PersonName + "："
                    }}{{ !item.TicketNo ? "" : item.TicketNo }}；</span
                  ><br />&nbsp;&nbsp;<span id="etktNo"></span>
                </td>
                <td v-if="store.state.seledPDF=='one'">
                  <span id="PassengernameTktno">{{ item.PersonName + "："
                    }}{{ !item.TicketNo ? "" : item.TicketNo }}；</span
                  ><br />&nbsp;&nbsp;<span id="etktNo"></span>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td style="width: 100px; vertical-align: top">
                  <strong>{{store.state.seledLetter == "chTable" ? "提醒您注意":'Note'}}:</strong>
                </td>
                <td>
                  {{store.state.seledLetter == "chTable" ? "国内航班请提前90分钟，国际航班请提前2个小时到达机场，办理乘机和安检手续。":'Please go to the check-in desk 90minutes/2hours before departure for domestic/international flight.'}}
                </td>
              </tr>
            </tbody>
          </table>
          <table
            style="width: 100%; margin-bottom: 20px"
            class="cke_show_border item-order-text"
          >
            <tbody>
              <tr>
                <td style="width: 100px; vertical-align: top">
                  <strong>{{store.state.seledLetter == "chTable" ? "免责声明":'Liability Disclaimer'}}：</strong>
                </td>
                <td>
                  {{store.state.seledLetter == "chTable" ? "以上所展示的航班、舱位、机型、起飞时间、到达时间、行李、价格信息仅供参考，在出票前可能发生变动。":'The flight, cabin, models, departure time, arrival time, the luggage, the price information is for reference only, in the event of changes before the vote.'}}
                  <br />{{store.state.seledLetter == "chTable" ? "另外，航班可能因为天气等原因受到影响，造成延误或取消，请您实时关注航班变化，与所乘航空公司密切沟通。":'On the other, flights may be affected because of weather and other reasons, resulting in delayed or canceled, please pay close attention to changes in real time flight, in close communication with the airline.'}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="padding: 0 50px">
          <p style="color: #ff661b; font-size: 14px">
            {{store.state.seledLetter == "chTable" ? "若您在旅行过程中遇到任何问题需要解决，请随时拨打我们的24小时免费电话……":'Should you have any further information, please feel free to contact us at ……'}}
          </p>
          <h3 style="text-align: center; color: #1abc9c;margin-top:12px;">{{store.state.seledLetter == "chTable" ? "祝您旅途愉快!":'Have a nice trip!'}}</h3>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script setup>
import { nextTick, ref } from "vue";
import htmlPdf from "@/utils/pdf.js";
import { useStore } from "vuex";

const store = useStore();
const allPrice = ref(0)
const listDom = ref(null)
const componentKey = ref(0)

function judgmentDate(text){
  let moonList = [
    {
      name:'JAN',
      num:'01'
    },
    {
      name:'FEB',
      num:'02'
    },
    {
      name:'MAR',
      num:'03'
    },
    {
      name:'APR',
      num:'04'
    },{
      name:'MAY',
      num:'05'
    },
    {
      name:'JUN',
      num:'06'
    },
    {
      name:'JUL',
      num:'07'
    },
    {
      name:'AUG',
      num:'08'
    },
    {
      name:'SEP',
      num:'09'
    },
    {
      name:'OCT',
      num:'10'
    },
    {
      name:'NOV',
      num:'11'
    },
    {
      name:'DEC',
      num:'12'
    }]
    let content = ''
  moonList.forEach((element)=>{
    if(element.name.toUpperCase() == text.toUpperCase()){
      content = element.num
    }
  })
  return content
}

function childPDF() {
  let TypeName = "电子行程单";
  if(store.state.seledPDF=='many'){
    htmlPdf(TypeName, document.querySelector(`#pdf-many-table0`));
  }else {
    store.state.dataTickets = store.state.resolveData.Tickets
    nextTick(()=>{
        listDom.value.forEach((element1,index)=>{
        element1.innerHTML = listDom.value[0].innerHTML
        element1.querySelector('#passengerNameList').innerText = store.state.dataTickets[index].PersonName
        element1.querySelector('#PassengernameTktno').innerText = store.state.dataTickets[index].PersonName + "：" + (!store.state.dataTickets[index].TicketNo ? ";" : store.state.dataTickets[index].TicketNo+';');
      })
      })

      nextTick(()=>{
      store.state.dataTickets.forEach((element,index)=>{
        htmlPdf(element.PersonName +TypeName, document.querySelector(`#pdf-many-table${index}`));
      })
      nextTick(()=>{
      componentKey.value = new Date()
      })
    })
  }
  
}

defineExpose({
  childPDF,
});
</script>

<style scoped>

.itinerary-right-list {
  width: 100%;
}

.itinerary-right-list:focus {
  border: 0;
  outline: none;
}

#pdf-many-table0{
  position: relative !important;
  z-index: 1000 !important;
  background-color: #fff;
}

.table-box {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 0;
}

.passenger-title {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  margin-top: 12px;
  align-items: flex-start;
}

.passenger-title p {
  line-height: 23px;
}


.item-order-text td {
  text-align: start;
}
</style>